import PropTypes from 'prop-types';
import React from 'react';
//Shift to pubweb-smokey
import WistiaVideoEmbed from '@components/Shared/WistiaVideoEmbed/WistiaVideoEmbed';

export const EmbeddedVideo = ({ videoSource, childMarkdownRemark }) => {
  return (
    <div>
      {/* If digital marketing uses a wistia video, they put nothing but the Wistia video's ID into the rawMarkdownBody field */}
      {videoSource === 'Wistia' ? (
        <WistiaVideoEmbed wistiaID={childMarkdownRemark} />
      ) : null}

      {videoSource === 'YouTube' ? (
        <div className="iframe-container">
          <iframe
            title="Clayton Homes | YouTube"
            src={`https://www.youtube.com/embed/${childMarkdownRemark}`}
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          ></iframe>
        </div>
      ) : null}

      {videoSource === 'Widen' ? (
        <div className="iframe-container">
          <iframe
            title="Clayton Homes | Widen"
            src={`https://embed.widencdn.net/video/claytonhomes/${childMarkdownRemark}`}
            frameBorder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowFullScreen
            scrolling="no"
          ></iframe>
        </div>
      ) : null}

      {videoSource === 'Vimeo' ? (
        <div className="iframe-container">
          <iframe
            title="Clayton Homes | Vimeo"
            src={`https://player.vimeo.com/video/${childMarkdownRemark}`}
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
          ></iframe>
        </div>
      ) : null}
    </div>
  );
};

EmbeddedVideo.propTypes = {
  childMarkdownRemark: PropTypes.any,
  videoSource: PropTypes.string,
};

export default EmbeddedVideo;
